'use client'

import {useSyncExternalStore} from 'react'

function subscribe(onStoreChange: () => void) {
  window.addEventListener('online', onStoreChange)
  window.addEventListener('offline', onStoreChange)
  return () => {
    window.removeEventListener('online', onStoreChange)
    window.removeEventListener('offline', onStoreChange)
  }
}

function getSnapshot(): boolean {
  return navigator.onLine
}

function getServerSnapshot(): boolean {
  return true
}

export function useNetworkOnline(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

type NetworkConnection = EventTarget & {
  effectiveType?: string
  rtt?: number
}

const WEAK_EFFECTIVE_TYPES = new Set(['slow-2g', '2g', '3g'])

function getNetworkConnection(): NetworkConnection | null {
  if (typeof navigator === 'undefined') return null

  const nav = navigator as Navigator & {
    connection?: NetworkConnection
    mozConnection?: NetworkConnection
    webkitConnection?: NetworkConnection
  }

  return nav.connection ?? nav.mozConnection ?? nav.webkitConnection ?? null
}

export function isNetworkConnectionWeak(): boolean {
  const connection = getNetworkConnection()
  if (!connection) return false

  const effectiveType = connection.effectiveType
  const roundTripTime = connection.rtt

  return (
    (effectiveType !== undefined && WEAK_EFFECTIVE_TYPES.has(effectiveType)) ||
    (typeof roundTripTime === 'number' && roundTripTime > 500)
  )
}

function subscribeToConnectionChange(onStoreChange: () => void) {
  const connection = getNetworkConnection()
  if (!connection) return () => {}

  connection.addEventListener('change', onStoreChange)
  return () => connection.removeEventListener('change', onStoreChange)
}

function getWeakConnectionServerSnapshot(): boolean {
  return false
}

export function useIsConnectionWeak(): boolean {
  return useSyncExternalStore(
    subscribeToConnectionChange,
    isNetworkConnectionWeak,
    getWeakConnectionServerSnapshot
  )
}
